import {
  getFiles,
  deleteFile,
  uploadFileWithProgress,
} from '@ps/api/editor/file'
import { del, create, list } from '@ps/api/setting'
import { v2Host } from '@/config/host'
import { projectBasicPath } from '@ps/workbench/config'
import gameIframe from '@ps/bridge/iframe/iframe'
import * as bgScript from '@ps/bridge/qc/scripts/bg-config'
const resource = {
  namespaced: true,

  state: {
    resource: null,
  },

  mutations: {
    updateResource(state, { resource }) {
      state.resource = resource
    },
  },

  actions: {
    saveCustomCurve({ commit, state }, { name, data, type }) {
      return new Promise((resolve, reject) => {
        create({
          type: type || 1,
          name: name,
          data: data,
        })
          .then((res) => {
            if (res.code === 0) {
              resolve(res)
            } else {
              reject(res.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteCustomCurve({ commit, state }, { id }) {
      return new Promise((resolve, reject) => {
        del({ id })
          .then((res) => {
            if (res.code === 0) {
              resolve(res)
            } else {
              reject(res.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getCustomCurve({ commit, state }, { type, page, pageSize }) {
      return new Promise((resolve, reject) => {
        list({ type: type || 1, page: page || 1, page_size: pageSize || 12 })
          .then((res) => {
            if (res.code === 0) {
              if (res.data.list !== null) {
                res.data.list.forEach((item, i) => {
                  try {
                    item.data = JSON.parse(item.data)
                  } catch (e) {
                    item.data = ''
                  }
                })
              }
              resolve(res.data)
            } else {
              reject(res.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    getProjectResource({ commit, state }, { projectKey }) {
      return new Promise((resolve, reject) => {
        getFiles({ pid: projectKey })
          .then((res) => {
            if (res.code === 0) {
              const resource = res.data.result.items
              commit('updateResource', { resource })
              resolve(res)
            } else {
              reject(res.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteResource({ commit, state }, { projectKey, path, recursive }) {
      return new Promise((resolve, reject) => {
        deleteFile({ pid: projectKey, path, recursive })
          .then((res) => {
            if (res.code === 0) {
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    uploadBackgroundMusic({ commit, state }, { data }) {
      const filePath = data.backgroundMusicPath
      const targetUrl =
        v2Host +
        '/ps/editor/file/save?pid=' +
        data.projectKey +
        '&path=' +
        encodeURIComponent(filePath)
      const musicPath = projectBasicPath + data.projectKey + '/' + filePath
      data.filePath = filePath
      data.targetUrl = targetUrl
      data.musicPath = musicPath
      const success = data.success
      data.success = () => {
        success({ musicPath })
      }
      uploadFileWithProgress(data)
    },
    uploadBackgroundImage({ commit, rootState }, { data }) {
      let filePath = ''
      const gamePlay = gameIframe.gamePlay
      const bgConfig = bgScript.getScript(gamePlay, false)
      if (bgConfig) {
        filePath = bgConfig.bgUrl
      } else {
        filePath = rootState.workspace.globalConfig.bgUrl
      }
      const targetUrl =
        v2Host +
        '/ps/editor/file/save?pid=' +
        data.projectKey +
        '&path=' +
        encodeURIComponent(filePath)
      const imagePath = projectBasicPath + data.projectKey + '/' + filePath
      data.filePath = filePath
      data.targetUrl = targetUrl
      data.imagePath = imagePath
      const success = data.success
      data.success = () => {
        success({ imagePath })
      }
      uploadFileWithProgress(data)
    },
    uploadFilterBackgroundImage({ commit, rootState }, { data }) {
      const filePath = data.filePath
      const targetUrl =
        v2Host +
        '/ps/editor/file/save?pid=' +
        data.projectKey +
        '&path=' +
        encodeURIComponent(filePath)
      const imagePath = projectBasicPath + data.projectKey + '/' + filePath
      data.filePath = filePath
      data.targetUrl = targetUrl
      data.imagePath = imagePath
      const success = data.success
      data.success = () => {
        success({ imagePath })
      }
      uploadFileWithProgress(data)
    },
  },
}

export default resource
